import Button from 'shared/components/Button'
import Form from 'shared/components/Form'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const ContainerIcon = styled.div`
  display: flex;
  width: 70px;
  height: 70px;
  border: 2px solid ${colors.blue};
  border-radius: 50%;
  align-items: center;
  justify-content: center;

  svg {
    width: 35px;
    height: 35px;

    transform: rotate(90deg);
  }
`

export const StyledForm = styled(Form)`
  padding: 0px;
`

export const ContainerContent = styled.div`
  display: flex;

  flex-direction: column;
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  input {
    width: 60%;
  }
`
export const ContainerText = styled.div`
  padding: 15px;
`

export const ContainerInput = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;

  button {
    margin-top: 20px;
  }
`

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
export const ResendButton = styled(Button)`
  width: 185px;
  color: ${props => (props.disabled ? colors.gray7 : colors.green)};
  background: none;
  margin-top: 0px !important;
`
export const Container = styled.div`
  width: 100vw;
  display: flex;

  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  input {
    width: 40vw;
    max-width: 513px;
  }
`
